export default __webpack_public_path__ + "static/media/iACST_Hero_new.162ef4d7.png";